import {scrollToSection} from './scrollHelper';

function scrollToNavTab(tabName, duration = 500) {
    const element = window.document.querySelector(`#${tabName}`);
    const elementRect = element.getClientRects();
    const navBar = window.document.querySelector('.listing-page__nav');
    const navBarRect = navBar.getClientRects();
    const extraPush = 2;
    const change = elementRect['0'].top - navBarRect['0'].height + extraPush;

    scrollToSection(change, duration);
}

export default scrollToNavTab;
export {
    scrollToNavTab
};
